import { Collapse } from 'antd';
import {
  StyledDrawer,
  StyledCollapse,
  CountryText,
  DeclinesWrapper,
  AllowedPublishersText,
  CountryStatusWrapper,
  CountrySectionWrapper,
} from './styles';
import SourcesTable from './SourcesTable';
import reviewDeclinedIcon from './images/reviewDeclinedIcon.svg';
import {
  ADOMAIN_KEY,
  ASSET_ID_KEY,
  ASSET_NAME_KEY,
  ASSET_SOURCES_KEY,
  BRAND_ID_KEY,
  BRAND_NAME_KEY,
  CREATED_AT_KEY,
  DSP_ID_KEY,
  DSP_NAME_KEY,
  EXTERNAL_PARTNER_KEY,
  INGESTION_TYPE_KEY,
  MEDIA_FILE_URL_KEY,
  SUGGESTED_BRAND_CRM_ID_KEY,
  SUGGESTED_BRAND_CRM_NAME_KEY,
  TRACKING_ID_KEY,
  TRANSCODE_STATUS_KEY,
  UPDATED_AT_KEY,
  VIDEO_METADATA_KEY,
} from '../constants';
import moment from 'moment-timezone';
import { COUNTRY_CODE_TO_NAME_MAP } from '../../../i18n';
import ReasonsTable from './ReasonsTable';

const { Panel } = Collapse;

const DetailPanel = ({ isOpen, onClose, data, statusItemRenderer }) => {
  if (!data) return null;

  return (
    <StyledDrawer
      title={`Asset Details: ${data['asset-name']}`}
      placement="right"
      onClose={onClose}
      open={isOpen}
      width={600}
      destroyOnClose
      motion={{
        motionName: 'ant-slide',
        motionAppear: true,
        motionEnter: true,
        motionLeave: true,
      }}
    >
      {' '}
      <StyledCollapse defaultActiveKey={['assetInfo', 'sources', 'countries']}>
        {/* Countries Section */}
        <Panel header="Countries" key="countries">
          {data['country-reviews']?.map((review, index) => (
            <CountrySectionWrapper key={index}>
              <CountryStatusWrapper>
                <CountryText>{COUNTRY_CODE_TO_NAME_MAP[review.country] || review.country}</CountryText>
                {statusItemRenderer(review.status)}
              </CountryStatusWrapper>
              <AllowedPublishersText>{review['allowed-publishers']?.join(', ')}</AllowedPublishersText>
              {review.declines?.length > 0 && (
                <DeclinesWrapper style={{ display: 'flex', alignItems: 'center', gap: '12px', marginTop: '8px' }}>
                  <img src={reviewDeclinedIcon} alt="Declined Icon" style={{ marginTop: 0 }} />
                  <div style={{ maxHeight: '300px', overflowY: 'auto', marginRight: 8, flex: 1 }}>
                    <ReasonsTable declines={review.declines} />
                  </div>
                </DeclinesWrapper>
              )}
            </CountrySectionWrapper>
          ))}
        </Panel>

        {/* Sources Section */}
        <Panel header="Sources" key="sources">
          <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
            <SourcesTable sources={data['asset-sources']} />
          </div>
        </Panel>

        {/* Asset Info Section */}
        <Panel header="Asset Info" key="assetInfo">
          <p>
            Brand Name:{' '}
            {data.brand
              ?.map((brand) => brand[BRAND_NAME_KEY])
              .filter(Boolean)
              .join(', ') || ''}
          </p>
          <p>
            Brand ID:{' '}
            {data.brand
              ?.map((brand) => brand[BRAND_ID_KEY])
              .filter(Boolean)
              .join(', ') || ''}
          </p>
          <p>
            Suggested Brand Name:{' '}
            {[...new Set(data[ASSET_SOURCES_KEY]?.map((source) => source[SUGGESTED_BRAND_CRM_NAME_KEY]))]
              .filter(Boolean)
              .join(', ') || ''}
          </p>
          <p>
            Suggested Brand ID:{' '}
            {[...new Set(data[ASSET_SOURCES_KEY]?.map((source) => source[SUGGESTED_BRAND_CRM_ID_KEY]))]
              .filter(Boolean)
              .join(', ') || ''}
          </p>
          <p>Asset Name: {data[ASSET_NAME_KEY]}</p>
          <p>Asset ID: {data[ASSET_ID_KEY]}</p>
          <p>Created At: {moment.utc(data[CREATED_AT_KEY]).local().format('MM/DD/YYYY HH:mm:ss')}</p>
          <p>Last Updated At: {moment.utc(data[UPDATED_AT_KEY]).local().format('MM/DD/YYYY HH:mm:ss')}</p>
          <p>
            Adomain:{' '}
            {[...new Set(data[ASSET_SOURCES_KEY]?.map((source) => source[ADOMAIN_KEY]))].filter(Boolean).join(', ') ||
              ''}
          </p>
          <p>
            Media File URL:{' '}
            {[...new Set(data[ASSET_SOURCES_KEY]?.map((source) => source[MEDIA_FILE_URL_KEY]))]
              .filter(Boolean)
              .join(', ') || ''}
          </p>
          <p>
            Dsp ID:{' '}
            {[...new Set(data[ASSET_SOURCES_KEY]?.map((source) => source[DSP_ID_KEY]))].filter(Boolean).join(', ') ||
              ''}
          </p>
          <p>
            Dsp Name:{' '}
            {[...new Set(data[ASSET_SOURCES_KEY]?.map((source) => source[DSP_NAME_KEY]))].filter(Boolean).join(', ') ||
              ''}
          </p>
          <p>
            External Partner:{' '}
            {[...new Set(data[ASSET_SOURCES_KEY]?.map((source) => source[EXTERNAL_PARTNER_KEY]))]
              .filter(Boolean)
              .join(', ') || ''}
          </p>
          <p>
            Ingestion Type:{' '}
            {[...new Set(data[ASSET_SOURCES_KEY]?.map((source) => source[INGESTION_TYPE_KEY]))]
              .filter(Boolean)
              .join(', ') || ''}
          </p>
          <p>
            Tracking ID:{' '}
            {[...new Set(data[ASSET_SOURCES_KEY]?.map((source) => source[TRACKING_ID_KEY]))]
              .filter(Boolean)
              .join(', ') || ''}
          </p>

          <p>Transcode Status: {data[TRANSCODE_STATUS_KEY] || ''}</p>
          {data[VIDEO_METADATA_KEY] && (
            <>
              <p>Duration: {data[VIDEO_METADATA_KEY].duration}</p>
              <p>Width: {data[VIDEO_METADATA_KEY].width}</p>
              <p>Height: {data[VIDEO_METADATA_KEY].height}</p>
            </>
          )}
        </Panel>
      </StyledCollapse>
    </StyledDrawer>
  );
};

export default DetailPanel;
